import React, { useState, useEffect, useRef, useCallback } from "react";
import { Container, Button } from "react-bootstrap";
import Alert from "react-s-alert";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import propTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  Grid,
  Checkbox,
  Divider,
  InputAdornment,
  IconButton,
  OutlinedInput,
  TextField,
  Chip,
  List,
  ListItem,
} from "@material-ui/core";
import { Row, Col, Table, Modal, Image, Form } from "react-bootstrap";
import ChooseUserAttributes from "../../superAdminAllComponent/SuperAdminSMSTemplateManagement/ChooseUserAttributes";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import FormatColorTextOutlinedIcon from "@material-ui/icons/FormatColorTextOutlined";
import ColorPicker from "../../../reusableComponents/colorPicker/colorPicker";
import { SuperAdminEditTemplate } from "../SuperAdminSMSTemplateManagement/SuperAdminEditTemplate";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import FormatColorFillOutlinedIcon from "@material-ui/icons/FormatColorFillOutlined";
import NotifyTemplate from "./NotifyTemplate";
import SingleImageReusableComponent from "../../../reusableComponents/imageUploadReusableComponent/SingleImageReusableComponent";
import axios from "axios";
import { serverApi, imageUploadSize } from "../../../../config/Keys";
import moment from "moment";
import { PopupActionButton } from "../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import SelectMapLocation from "../../../reusableComponents/selectMapLocation/selectMapLocation";
import { GetAddressFromLatLng } from "../SuperAdminAddVendorComponent/MapSetup/MapUtils";
import isEmpty from "../../../../store/validation/is-Empty";
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { NewInputText } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import {
  update_get_in_app_templates,
  add_in_app_templates,
} from "../../../../store/actions/SuperAdminActions/adminTemplatesAction";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import { amApi } from "../../../../api/apiHelper";
import { errorAlert } from "../../../../function/alert";
import { AddButtonIconComponent } from "../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
// import SelectMapLocation from "../../../reusableComponents/selectMapLocation/selectMapLocation";
import { Select as MuiSelect } from "@material-ui/core";
import Debounce from "../../../../function/debounce";

const modes = ["KMS", "Meters", "Miles"];
function SuperAdminNotifyUsersCreate(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const locationState = useLocation();
  const auth = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth.user : "";
  });
  const data = locationState?.state?.data || null;
  const [template, setTemplate] = useState(data?.templateType || "TEXT");
  const [notificationType, setNotificationType] = useState(
    data?.userType || "USER"
  );
  const geoType = [
    { value: "STATE", label: "State" },
    { value: "CITY", label: "City" },
  ];
  const [locationType, setLocationType] = useState(
    data?.locationType || "STATE"
  );
  const [heading, setHeading] = useState({
    color: data?.heading?.color || "#333",
    value: data?.heading?.text || "Sample Headline",
    picker: false,
  });
  const [content, setContent] = useState({
    color: data?.content?.color || "#333",
    value: data?.content?.text || "Sample Subtext",
    picker: false,
  });
  const [background, setBackground] = useState({
    color: data?.background || "#fff",
    picker: false,
  });
  const [clickable, setClickable] = useState(data?.isClickable || false);
  const [image, setImage] = useState({
    file: null,
    url: data?.image || "",
    singleImageLoader: false,
    actionButton: true,
    combined: "",
  });
  const [targetScreen, setTargetScreen] = useState({
    name: data?.targetScreen?.name || "",
    query: data?.targetScreen?.query || "",
  });
  const [notificationTime, setNotificationTime] = useState({
    startDate: data?.startDate
      ? moment(data?.startDate).format("YYYY-MM-DD")
      : "",
    endDate: data?.endDate ? moment(data?.endDate).format("YYYY-MM-DD") : "",
    startTime: data?.startTime || "",
    endTime: data?.endTime || "",
  });
  const [location, setLocation] = useState({
    markers: data?.locationMarkers || [],
    list: data?.locationList || [],
  });
  const [title, setTitle] = useState(data?.title || "");

  const onChangeHandler = (type) => (color) => {
    if (type === "HEADING")
      setHeading({ ...heading, color: color, picker: !heading.picker });
    if (type === "SUBTEXT")
      setContent({ ...content, color: color, picker: !content.picker });
    if (type === "BACKGROUND")
      setBackground({ color: color, picker: !background.picker });
  };

  const onImageLogoUploadHandler = (e) => {
    if (e.target.files[0] && e.target.files[0].size > imageUploadSize) {
      alert("File is too Big");
    } else {
      setImage({
        ...image,
        file: e.target.files[0],
        combined: `notification_${Date.now()}`,
      });
    }
  };

  const [state1, setstate1] = useState({
    email: "",
  });

  const [state, setState] = useState({
    search: "",
    code: props.auth.user.VendorUser.country_code,
    Language: "English",
  });

  const removeFile = (e) => {
    setImage({
      image: "",
      actionButton: true,
    });
  };

  const onCompleteCrop = (url) => {
    setImage({
      url: url,
      file: null,
      singleImageLoader: false,
      actionButton: true,
    });
  };

  const onCancelCrop = () => {
    setImage({ ...image, file: null });
  };

  const [wholeData, setWholedata] = useState({});
  const [checkpreferences,setcheck]=useState(true)
  const [showUserAdd, setuserAdd] = useState(false);
  const [displayDropDown, setdisplayDropDown] = useState(true);
  const onNextHoursOpen = () => setdisplayDropDown(!displayDropDown);
  const [displayDropDownlocations, setdisplayDropDownlocations] =
    useState(true);
  const onOpenAddedlocations = () =>
    setdisplayDropDownlocations(!displayDropDownlocations);

  //setting array id's //
  let [genderids, setgenderids] = useState([]);
  let [allergiesids, setAllergies] = useState([]);
  let [cusinesids, setcusinesids] = useState([]);
  let [dietaryids, setdietary] = useState([]);

  useEffect(() => {
    assignvalues();
    // filterder_attributes();
  }, [wholeData]);

  const assignvalues = () => {
    if (wholeData?.gender) {
      wholeData.gender.map((data, index) => {
        genderids.push(data.value);
      });
    }
    if (wholeData?.Allergies?.length) {
      wholeData.Allergies.map((data, index) => {
        allergiesids.push(data.value);
      });
    }
    if (wholeData?.Cuisines?.length) {
      wholeData.Cuisines.map((data, index) => {
        cusinesids.push(data.value);
      });
    }
    if (wholeData?.Dietary?.length) {
      wholeData.Dietary.map((data, index) => {
        dietaryids.push(data.value);
      });
    }
  };

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [userData, setUserData] = useState({
    mobile_number: "",
    email: "",
    data: null,
  });

  const [locationPointers, setLocationPointers] = useState({
    markers: [],
    list: [],
  });

  const [rest, setRest] = useState({ restaurant_name: "" });

  const [rests, setRests] = useState([]);

  const [locData, setLocData] = useState({
    lat: "",
    lng: "",
    radius: "",
    radiusType: "KMS",
  });

  const [addLocations, setAddLocations] = useState([]);

  // const onLocationSelect = async (loc) => {
  //   let lat = loc.latLng.lat();
  //   let lng = loc.latLng.lng();
  //   let res = await GetAddressFromLatLng(lat, lng);
  //   if (locationType === "STATE" && !location.list.includes(res.state)) {
  //     setLocation({
  //       markers: [...location.markers, { lat: lat, lng: lng }],
  //       list: [...location.list, res.state],
  //     });
  //   } else if (locationType === "CITY" && !location.list.includes(res.city)) {
  //     setLocation({
  //       markers: [...location.markers, { lat: lat, lng: lng }],
  //       list: [...location.list, res.city],
  //     });
  //   }
  // };

  const handleChangeCode = (event) => {
    const code = event.target.name;
    setState({
      ...state,
      [code]: event.target.value,
    });
  };

  const onUserSearch = async (event) => {
    try {
      let query = {};
      let emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
      if (event.length === 10 && !isNaN(Number(event))) {
        query.mobile_number = event;
        query.country_code = state.code;
      } else if (emailRegex.test(event)) {
        query.email = event;
      }

      if (!isEmpty(query)) {
        let userData = await amApi.get(`/user-check`, { params: query });
        //     console.log('userData', userData)
        if (userData.status === 200 && !isEmpty(userData.data)) {
          setuserAdd(true);
          setUserData({
            mobile_number: userData?.data?.mobile_number,
            email: userData?.data?.email,
            data: userData?.data,
          });
          if (!state1.email) {
            setstate1({
              ...state1,
              email: userData?.data?.email,
            });
          }
        } else {
          setuserAdd(false);
        }
      }
    } catch (err) {
      errorAlert("User Not Found");
      setuserAdd(false);
      setUserData({
        ...userData,
        data: null,
      });
    }
  };

  const onSelectUsers = (data) => {
    if (!isEmpty(data)) {
      let d = [
        ...selectedUsers,
        {
          _id: data?._id,
          first_name: data?.first_name,
          last_name: data?.last_name,
          mobile_number: data?.mobile_number,
          email: data?.email,
          country_code: data?.country_code,
        },
      ];
      setSelectedUsers(d);
    }
  };

  const onDeleteUsers = (data) => {
    let d = selectedUsers.filter((e) => e?._id !== data?._id);
    setSelectedUsers(d);
  };

  const onDeleteLocations = (data) => {
    let d = addLocations.filter((e) => e?.lat !== data?.lat);
    setAddLocations(d);
  };

  const onAddLocation = (data) => {
    let d = rest?.restaurant_name
      ? rest.restaurant_name
      : `Lat : ${parseInt(locData.lat).toFixed(4)} - Lng : ${parseInt(
        locData.lng
      ).toFixed(4)}`;
    setLocationPointers({
      markers: [
        ...locationPointers.markers,
        { lat: Number(locData.lat), lng: Number(locData.lng) },
      ],
      list: [...locationPointers.list, d],
    });
    setAddLocations([
      ...addLocations,
      {
        restaurant_name: rest?.restaurant_name || "",
        ...locData,
      },
    ]);
    setLocData({
      lat: "",
      lng: "",
      radius: "",
      radiusType: "KMS",
    });
    setRest({
      restaurant_name: "",
    });
  };

  const onLocationSelect = async (loc) => {
    let lat = loc.latLng.lat();
    let lng = loc.latLng.lng();
    setLocData({
      ...locData,
      lat: lat,
      lng: lng,
    });
  };

  const onRestSelect = (data) => {
    setRests([]);
    setRest({
      restaurant_name: data.restaurant_name,
      lat: data.location.coordinates[1],
      lng: data.location.coordinates[0],
    });
    setLocData({
      ...locData,
      lat: data.location.coordinates[1],
      lng: data.location.coordinates[0],
    });
  };

  // const filterder_attributes = () => {
  //   if (wholeData?.DobStarDate && wholeData?.DobSEndDate) {
  //     return (
  //       <>
  //         <div className="f10-400 my-1">
  //           <span
  //             style={{ color: "#EE3A23", fontSize: "14px", fontWeight: "700" }}
  //           >
  //             {" "}
  //             Date of birth :
  //           </span>{" "}
  //           <span>
  //             {" "}
  //             From : {wholeData?.DobStarDate} To : {wholeData?.DobSEndDate}
  //           </span>
  //         </div>
  //       </>
  //     );
  //   }
  //   if (wholeData?.ActiveUsersStartdate && wholeData?.ActiveUsersenddate) {
  //     return (
  //       <div className="f10-400 my-1">
  //         <span
  //           style={{ color: "#EE3A23", fontSize: "14px", fontWeight: "700" }}
  //         >
  //           {" "}
  //           Active User's paramaters :
  //         </span>{" "}
  //         <span>
  //           {" "}
  //           From : {wholeData?.ActiveUsersStartdate} To :{" "}
  //           {wholeData?.ActiveUsersenddate}
  //         </span>
  //       </div>
  //     );
  //   }
  //   if (wholeData?.AnniversaryStarDate && wholeData?.AnniversaryEndDate) {
  //     return (
  //       <div className="f10-400 my-1">
  //         <span
  //           style={{ color: "#EE3A23", fontSize: "14px", fontWeight: "700" }}
  //         >
  //           {" "}
  //           User's Anniversary with Amealio :
  //         </span>{" "}
  //         <span>
  //           {" "}
  //           From : {wholeData?.AnniversaryStarDate} To :{" "}
  //           {wholeData?.AnniversaryEndDate}
  //         </span>
  //       </div>
  //     );
  //   }
  //   if (wholeData?.country) {
  //     return (
  //       <div className="f10-400 my-1">
  //         <span
  //           style={{ color: "#EE3A23", fontSize: "14px", fontWeight: "700" }}
  //         >
  //           {" "}
  //           country :
  //         </span>{" "}
  //         <span>{wholeData?.country}</span>
  //       </div>
  //     );
  //   }
  //   if (wholeData?.state) {
  //     return (
  //       <div className="f10-400 my-1">
  //         <span
  //           style={{ color: "#EE3A23", fontSize: "14px", fontWeight: "700" }}
  //         >
  //           {" "}
  //           state :
  //         </span>{" "}
  //         <span>{wholeData?.state}</span>
  //       </div>
  //     );
  //   }
  //   if (wholeData?.city) {
  //     return (
  //       <div className="f10-400 my-1">
  //         <span
  //           style={{ color: "#EE3A23", fontSize: "14px", fontWeight: "700" }}
  //         >
  //           {" "}
  //           city :
  //         </span>{" "}
  //         <span>{wholeData?.city}</span>
  //       </div>
  //     );
  //   }
  // };
  

  const onChange = async (value) => {
    try {
      if (value) {
        let data = await amApi.get(`/searchRestaurant?name=${value}`);
        data = data.data;
        setRests(data);
      }
    } catch (err) {
      errorAlert("Something went wrong, try again later");
    }
  };
 // console.log(selectedUsers, "array");

  const debounceOnChange = useCallback(Debounce(onChange, 1000), []);

  const onSuccess = () => {
    Alert.success(`<h4>Notification Saved Successfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    history.push("/superadminnotifyusers");
  };

  const submitNotification = async () => {
    let formData = {
      title: title,
      userType: notificationType,
      templateType: template,
      isClickable: clickable,
      locationType: locationType,
      locationList: location.list,
      locationMarkers: location.markers,
      startData: notificationTime.startDate,
      endDate: notificationTime.endDate,
      startTime: notificationTime.startTime,
      endTime: notificationTime.endTime,
      preferences: {
        dobFrom: wholeData?.DobStarDate,
        dobTo: wholeData?.DobSEndDate,
        anniversaryFrom: wholeData?.AnniversaryStarDate,
        anniversaryTo: wholeData?.AnniversaryEndDate,
        activeUsersFrom: wholeData?.ActiveUsersStartdate,
        activeUsersTo: wholeData?.ActiveUsersenddate,
        country: [wholeData?.country],
        state: [wholeData?.state],
        city: [wholeData?.city],
        gender: genderids,
        cuisines: cusinesids,
        allergies: allergiesids,
        dietary: dietaryids,
      }, // You need to send me the object
      locationBased: addLocations?.length ? true : false,
      locations: addLocations?.length ? { type: "Point", coordinates: [addLocations[0].lng, addLocations[0].lat] } : { type: "Point", coordinates: [-90, 90] },
      radius: addLocations[0]?.radius,
      radiusType: addLocations[0]?.radiusType,
      selectedUsers: selectedUsers,
      sendToAll: wholeData?.sendToAll === 0 ? true : false // Need to change by variable
    };
    if (template === "TEXT" || template === "TEXT_IMAGE") {
      formData.heading = { color: heading.color, text: heading.value };
      formData.content = { color: content.color, text: content.value };
      formData.background = background.color;
    }
    if (template === "TEXT_IMAGE" || template === "IMAGE") {
      formData.image = image.url;
    }
    if (clickable) {
      formData.targetScreen = targetScreen;
    }
    if (
     ( formData.startDate ||
      formData.endDate ||
      formData.startTime ||
      formData.endTime ||
      location.list.length  ) && 
      (addLocations?.length > 0 || selectedUsers?.length > 0 ||(!isEmpty(wholeData) && checkpreferences ))
    ) {
      if (!data?._id) {
        dispatch(add_in_app_templates(auth.accessToken, formData, onSuccess));
      } else {
        dispatch(
          update_get_in_app_templates(
            auth.accessToken,
            data._id,
            formData,
            onSuccess
          )
        );
      }
    } else {
      Alert.error(`<h4>Please select required fields</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };
 console.log(checkpreferences,"check");
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <Container fluid>
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center pt-4 pb-3 col">
                  <div className="f24_700_HelveticaNeue ">{`${data ? "Edit" : "Add"
                    } In App Notification`}</div>
                </div>
              </div>
              <div className="f18-700 mt-2">Select User Type*</div>
              <div className="col-11 p-0 mt-4 mb-3">
                <div className="d-flex align-items-center justify-content-between">
                  <ChooseUserAttributes
                    AttributesData={(e) => setWholedata(e)}
                      datacheck={(e) => setcheck(e)}
                  />
                </div>
                <div className="col-11 my-2">
                  <SelectedAttributes wholeData={wholeData} />
                  {/* {filterder_attributes()} */}
                </div>

                <div className="col-12 p-0">
                  <hr />
                </div>
              </div>
              <div>
                <div className="f18-700 my-1">Search Users by</div>
                <div className="f12-400 opacity5">
                  You can search for all the active users irrespective of
                  selected attributes
                </div>
                <div className="col-9 my-4 align-items-center">
                  <Row>
                    <Col xs={2} className="pr-0">
                      <FormControl variant="outlined" className="w-100">
                        <Select
                          value={state.code}
                          onChange={handleChangeCode}
                          inputProps={{
                            name: "code",
                          }}
                        >
                          <option value={state.country_code}>
                            {state.country_code}
                          </option>
                          {getCountries().map((country) => (
                            <option
                              key={country}
                              value={"+" + getCountryCallingCode(country)}
                            >
                              {en[country]} (+
                              {getCountryCallingCode(country)})
                            </option>
                          ))}
                        </Select>
                      </FormControl>
                    </Col>
                    <Col xs={4}>
                      <Form.Group>
                        <TextField
                          id="mobile_number"
                          //id="outlined-basic"
                          type="number"
                          max="10"
                          label="Phone Number"
                          variant="outlined"
                          className={`w-100`}
                          name="mobile_number"
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          onChange={(e) => onUserSearch(e.target.value)}
                        // value={formik1.values.mobile_number}
                        // onBlur={formik1.handleBlur}
                        //onInvalid={formik1.errors.email && formik1.touched.email}
                        // isInvalid={
                        //   formik1.errors.mobile_number &&
                        //   formik1.touched.mobile_number
                        // }
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group>
                        <NewInputText
                          id="email"
                          type="email"
                          label="Email Address"
                          variant="outlined"
                          className={`w-100`}
                          name="email"
                          onChange={(e) => setstate1({ email: e.target.value })}
                          // onChange={formik1.handleChange}
                          value={state1.email}
                          onFocusOut={() => {
                            if (
                              /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(
                                state1.email
                              )
                            ) {
                              onUserSearch(state1.email);
                            }
                          }}
                        // onBlur={formik1.handleBlur}
                        //onInvalid={formik1.errors.email && formik1.touched.email}
                        />
                      </Form.Group>
                    </Col>
                    {showUserAdd && (
                      <>
                        <Col md={2}>
                          <AddButtonIconComponent
                            buttonText="Add"
                            onClick={() => onSelectUsers(userData.data)}
                            fontIcon="fa fa-plus"
                            colorCss="blue"
                          />
                        </Col>
                      </>
                    )}
                  </Row>
                </div>
                <div className="my-4">
                  <div className="d-flex">
                    <h5
                      className="font_20_m c_red mr-3 cursor"
                      onClick={onNextHoursOpen}
                    >
                      Show Added Users
                    </h5>
                    <div className="cursor">
                      {displayDropDown ? (
                        <i
                          className="fa fa-angle-up c_red"
                          aria-hidden="true"
                          onClick={onNextHoursOpen}
                        ></i>
                      ) : (
                        <i
                          className="fa fa-angle-down c_red"
                          aria-hidden="true"
                          onClick={onNextHoursOpen}
                        ></i>
                      )}
                    </div>
                  </div>
                  {displayDropDown && selectedUsers.length ? (
                    selectedUsers.map((usr) => (
                      <>
                        <Row>
                          <Col xs={5}>
                            <span className="f14-600">
                              {usr.first_name || ""} {usr.last_name || ""}
                            </span>{" "}
                            <span className="f12-400">
                              {usr.mobile_number} {usr.email}
                            </span>
                          </Col>
                          <Col xs={3}>
                            <AddButtonIconComponent
                              buttonText="Delete"
                              onClick={() => onDeleteUsers(userData.data)}
                              fontIcon="fa fa-trash"
                              colorCss="delete"
                            />
                          </Col>
                        </Row>
                      </>
                    ))
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <hr />
              <div>
                <div className="f18-700 my-1">Search Restaurants by</div>
                <div className="f12-400 opacity5 mb-4">
                  You can search for all the active users irrespective of
                  selected attributes
                </div>
              </div>
              <div className="col-9 my-4 align-items-center">
                <Row>
                  <Col md={6} className="position-relative">
                    <Form.Group>
                      <TextField
                        id="restaurant"
                        type="text"
                        label="Search by Restaurant"
                        variant="outlined"
                        className={`w-100`}
                        name="search by restaurant"
                        value={rest?.name}
                        onChange={(e) => {
                          setRest({ name: e.target.value });
                          debounceOnChange(e.target.value);
                        }}
                      />
                    </Form.Group>
                    <div className="position-absolute bottom-0 w-100 mh-20">
                      <List
                        dense
                        className="w-100"
                        style={{ zIndex: 999, backgroundColor: "#ffffff" }}
                      >
                        {rests.length ? (
                          rests.map((rest) => (
                            <>
                              <ListItem
                                className="p-2 cursor-pointer"
                                onClick={(e) => onRestSelect(rest)}
                              >
                                {rest.restaurant_name}
                              </ListItem>
                              <Divider />
                            </>
                          ))
                        ) : (
                          <></>
                        )}
                      </List>
                    </div>
                  </Col>
                </Row>
              </div>
              <div className="d-flex">
                <div className="col-8">
                  <SelectMapLocation
                    location={locationPointers}
                    onSelectLocation={onLocationSelect}
                  />
                </div>
                <div className="col-4">
                  <div className="py-4">
                    <TextField
                      id="latitude"
                      type="number"
                      value={locData.lat}
                      label="Latitude"
                      variant="outlined"
                      className={`w-100`}
                      name="latitude"
                      onChange={(e) =>
                        setLocData({ ...locData, lat: e.target.value })
                      }
                    />
                  </div>
                  <div className="py-4">
                    <TextField
                      id="longitude"
                      type="number"
                      value={locData.lng}
                      label="Longitude"
                      variant="outlined"
                      className={`w-100`}
                      name="longitude"
                      onChange={(e) =>
                        setLocData({ ...locData, lng: e.target.value })
                      }
                    />
                  </div>
                  <p className="py-4 f16-700"> Within the Radius of</p>
                  <div className="d-flex justify-between">
                    <div className="col-8">
                      <TextField
                        id="radius"
                        type="number"
                        label="Radius"
                        variant="outlined"
                        className={`w-100`}
                        name="radius"
                        onChange={(e) =>
                          setLocData({ ...locData, radius: e.target.value })
                        }
                      />
                    </div>
                    <div className="col-4">
                      <MuiSelect
                        style={{ width: "100%" }}
                        value={locData.radiusType}
                        onChange={(e) =>
                          setLocData({ ...locData, radiusType: e.target.value })
                        }
                        variant="outlined"
                        label="Mode"
                        inputProps={{
                          name: "Mode",
                          id: "outlined-state",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {modes.map((mode, index) => (
                          <option key={index} value={mode}>
                            {mode}
                          </option>
                        ))}
                      </MuiSelect>
                    </div>
                  </div>
                  <div className="py-4">
                    {(isEmpty(locData?.lat) &&
                      isEmpty(locData?.lng) &&
                      isEmpty(locData?.radius) || addLocations.length >= 1) ? null : (
                      <AddButtonIconComponent
                        buttonText="Add Location"
                        onClick={() => onAddLocation(userData.data)}
                        fontIcon="fa fa-plus"
                        colorCss="blue"
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="my-4">
                <div className="d-flex">
                  <h5
                    className="font_20_m c_red mr-3 cursor"
                    onClick={onOpenAddedlocations}
                  >
                    Show Added Locations
                  </h5>
                  <div className="cursor">
                    {displayDropDownlocations ? (
                      <i
                        className="fa fa-angle-up c_red"
                        aria-hidden="true"
                        onClick={onOpenAddedlocations}
                      ></i>
                    ) : (
                      <i
                        className="fa fa-angle-down c_red"
                        aria-hidden="true"
                        onClick={onOpenAddedlocations}
                      ></i>
                    )}
                  </div>
                </div>
                {displayDropDownlocations && addLocations.length ? (
                  addLocations.map((loc) => (
                    <>
                      <Row>
                        <Col xs={5}>
                          <span className="f14-600">
                            {loc.restaurant_name || ""}{" "}
                          </span>{" "}
                          <span className="f12-400">
                            {loc.lat} - {loc.lng}
                          </span>
                        </Col>
                        <Col xs={3}>
                          <AddButtonIconComponent
                            buttonText="Delete"
                            onClick={() => onDeleteLocations(loc)}
                            fontIcon="fa fa-trash"
                            colorCss="delete"
                          />
                        </Col>
                      </Row>
                    </>
                  ))
                ) : (
                  <></>
                )}
              </div>
              <hr />
              {/* <div className="f16-600">User Type</div>
              <div>
                <FormControl component="fieldset">
                  <RadioGroup
                    row
                    aria-label="position"
                    name="position"
                    value={notificationType}
                    onChange={(e) => setNotificationType(e.target.value)}
                  >
                    <FormControlLabel
                      value="USER"
                      control={<Radio color="primary" />}
                      label="User"
                    />
                    <FormControlLabel
                      value="VENDOR"
                      control={<Radio color="primary" />}
                      label="Vendor"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <div className="f16-600">Select GEO Fence</div>
              <div>
                <FormControl variant="outlined" style={{ width: "280px" }}>
                  <Select
                    id="code"
                    name="code"
                    value={locationType}
                    onChange={(e) => {
                      setLocationType(e.target.value);
                      setLocation({ markers: [], list: [] });
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    {geoType.map((type) => (
                      <MenuItem key={type} value={type.value}>
                        {type.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div> 
              <br />
              <div>
                <SelectMapLocation
                  location={location}
                  onSelectLocation={onLocationSelect}
                />
              </div>
              <br />
              {location.list.length > 0 && (
                <Grid container spacing={2} alignItems="center">
                  <Grid item style={{ margin: "0px 2px" }}>
                    {`Selected ${
                      locationType === "STATE" ? "States" : "Cities"
                    } :`}
                  </Grid>
                  {location.list.map((e) => (
                    <Chip size="medium" label={e} />
                  ))}
                </Grid>
              )}
              <br />
                  <hr /> */}
              <Grid container spacing={1}>
                <Grid item xs={12} md={7}>
                  <div>Select Template</div>
                  <div>
                    <FormControl component="fieldset">
                      <RadioGroup
                        row
                        aria-label="position"
                        name="position"
                        value={template}
                        onChange={(e) => setTemplate(e.target.value)}
                      >
                        <FormControlLabel
                          value="TEXT"
                          control={<Radio color="primary" />}
                          label="Text"
                        />
                        <FormControlLabel
                          value="TEXT_IMAGE"
                          control={<Radio color="primary" />}
                          label="Text + Image"
                        />
                        <FormControlLabel
                          value="IMAGE"
                          control={<Radio color="primary" />}
                          label="Image"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                  <br />
                  <TextField
                    id="outlined-search"
                    label="Notification Title"
                    type="text"
                    variant="outlined"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    style={{ width: "280px" }}
                  />
                  <br />
                  {template !== "IMAGE" && (
                    <>
                      {" "}
                      <div style={{ marginTop: "16px" }}>
                        Background Color
                        <div
                          style={{
                            display: "inline-block",
                            marginLeft: "10px",
                            boxShadow: "0px 0px 10px gray",
                            borderRadius: "50%",
                          }}
                        >
                          <IconButton
                            size="medium"
                            onClick={() =>
                              setBackground({
                                ...background,
                                picker: !background.picker,
                              })
                            }
                          >
                            <FormatColorFillOutlinedIcon
                              style={{ color: background.color }}
                            />
                          </IconButton>
                        </div>
                        {background.picker && (
                          <ColorPicker
                            onColorChange={onChangeHandler("BACKGROUND")}
                          />
                        )}
                      </div>
                      <br />
                      <div>
                        <FormControl variant="outlined">
                          <InputLabel htmlFor="standard-adornment-password">
                            Headline
                          </InputLabel>
                          <OutlinedInput
                            id="standard-adornment-password"
                            type="text"
                            value={heading.value}
                            onChange={(e) =>
                              setHeading({ ...heading, value: e.target.value })
                            }
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  onClick={() =>
                                    setHeading({
                                      ...heading,
                                      picker: !heading.picker,
                                    })
                                  }
                                >
                                  <FormatColorTextOutlinedIcon
                                    style={{ color: heading.color }}
                                  />
                                </IconButton>
                              </InputAdornment>
                            }
                            labelWidth={70}
                          />
                        </FormControl>
                        {heading.picker && (
                          <ColorPicker
                            onColorChange={onChangeHandler("HEADING")}
                          />
                        )}
                      </div>
                      <br />
                      <div>
                        <FormControl variant="outlined">
                          <InputLabel htmlFor="standard-adornment-password">
                            Sub Text
                          </InputLabel>
                          <OutlinedInput
                            id="standard-adornment-password"
                            type="text"
                            value={content.value}
                            onChange={(e) =>
                              setContent({ ...content, value: e.target.value })
                            }
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  onClick={() =>
                                    setContent({
                                      ...content,
                                      picker: !content.picker,
                                    })
                                  }
                                >
                                  <FormatColorTextOutlinedIcon
                                    style={{ color: content.color }}
                                  />
                                </IconButton>
                              </InputAdornment>
                            }
                            labelWidth={70}
                          />
                        </FormControl>
                        {content.picker && (
                          <ColorPicker
                            onColorChange={onChangeHandler("SUBTEXT")}
                          />
                        )}
                      </div>
                    </>
                  )}
                  {template !== "TEXT" && (
                    <div>
                      <SimpleReactLightbox>
                        <SingleImageReusableComponent
                          title="Add Image*"
                          combined={image.combined}
                          onChange={onImageLogoUploadHandler}
                          onCompleteCrop={onCompleteCrop}
                          onCancelCrop={onCancelCrop}
                          file={image.file}
                          resetFile={removeFile}
                          name="Notification Image"
                        // error={errors.profile_Photo}
                        />
                      </SimpleReactLightbox>
                    </div>
                  )}
                  <br />
                  <div>
                    Is Notification Clickable ?{" "}
                    <Checkbox
                      checked={clickable}
                      onChange={(e) => setClickable(!clickable)}
                    />
                  </div>
                  {clickable && (
                    <>
                      <div>
                        <TextField
                          id="outlined-search"
                          label="Target Screen"
                          type="text"
                          style={{ width: "280px" }}
                          variant="outlined"
                          value={targetScreen.name}
                          onChange={(e) =>
                            setTargetScreen({
                              ...targetScreen,
                              name: e.target.value,
                            })
                          }
                        />
                      </div>
                      <br />
                      <div>
                        <TextField
                          id="outlined-search"
                          label="Search Query"
                          type="text"
                          style={{ width: "280px" }}
                          variant="outlined"
                          value={targetScreen.query}
                          onChange={(e) =>
                            setTargetScreen({
                              ...targetScreen,
                              query: e.target.value,
                            })
                          }
                        />
                      </div>
                    </>
                  )}
                </Grid>
                <Divider orientation="vertical" flexItem />
                <Grid item xs={12} md={4}>
                  <NotifyTemplate
                    background={background}
                    heading={heading}
                    content={content}
                    template={template}
                    image={image}
                  />
                </Grid>
                <br />
                <hr />
                <Grid item xs={12} style={{ marginTop: "8px" }}>
                  <Grid container spacing={2}>
                    <Grid item>
                      <TextField
                        id="date"
                        label="Start Date"
                        variant="outlined"
                        type="date"
                        defaultValue={moment().format("YYYY-MM-DD")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        style={{ minWidth: "140px" }}
                        value={notificationTime.startDate}
                        onChange={(e) =>
                          setNotificationTime({
                            ...notificationTime,
                            startDate: e.target.value,
                          })
                        }
                      />
                    </Grid>
                    <Grid item>
                      <TextField
                        id="date"
                        label="End Date"
                        variant="outlined"
                        type="date"
                        defaultValue={moment().format("YYYY-MM-DD")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        style={{ minWidth: "140px" }}
                        value={notificationTime.endDate}
                        onChange={(e) =>
                          setNotificationTime({
                            ...notificationTime,
                            endDate: e.target.value,
                          })
                        }
                      />
                    </Grid>
                    <Grid item>
                      <TextField
                        id="time"
                        label="Start Time"
                        variant="outlined"
                        type="time"
                        defaultValue="10:00"
                        style={{ minWidth: "100px" }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 300, // 5 min
                        }}
                        value={notificationTime.startTime}
                        onChange={(e) =>
                          setNotificationTime({
                            ...notificationTime,
                            startTime: e.target.value,
                          })
                        }
                      />
                    </Grid>
                    <Grid item style={{ minWidth: "60px" }}>
                      <TextField
                        id="time"
                        label="End Time"
                        variant="outlined"
                        type="time"
                        defaultValue="22:00"
                        style={{ minWidth: "100px" }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 300, // 5 min
                        }}
                        value={notificationTime.endTime}
                        onChange={(e) =>
                          setNotificationTime({
                            ...notificationTime,
                            endTime: e.target.value,
                          })
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <div className="py-4 d-flex align-items-center">
                    <Button
                      variant="outline-secondary"
                      className="btn-lg mr-4 px-5 btn150px"
                      onClick={() => {
                        history.push("/superadminnotifyusers");
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="danger"
                      className="btn-lg px-5 btn150px"
                      onClick={submitNotification}
                    >
                      Save
                    </Button>
                  </div>
                  {/* <div className="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5 bottom-button d-flex justify-content-end mt-4 add-diner-floating-button">
                    <PopupActionButton
                      buttonText="Cancel"
                      buttonType="button"
                      buttonClass={true ? "bigbuttongray" : "bigbuttonred"}
                      onClick={() => {
                        history.push("/superadminnotifyusers");
                      }}
                    />
                    <div className="margin-seating-left">
                      <PopupActionButton
                        buttonText="Save"
                        buttonType={"button"}
                        buttonClass="bigbuttonred"
                        onClick={submitNotification}
                      />
                    </div>
                  </div> */}
                </Grid>
              </Grid>
              <br />
              <hr />
            </Container>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
SuperAdminNotifyUsersCreate.propTypes = {
  auth: propTypes.object.isRequired,
  errors: propTypes.object.isRequired,
  // admin_get_user_vendor_info: propTypes.func.isRequired,
};

// export default SuperAdminNotifyUsersCreate;
const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  // getVendorUserDetails: state.superAdminTemplates.get_user_vendor_info,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  // admin_get_user_vendor_info,
})(withRouter(SuperAdminNotifyUsersCreate));

const SelectedAttributes = ({ wholeData }) => {
  return (
    <>
    {wholeData?.sendToAll === 0 ? (
      <>
        <div className="f10-400 my-1">
            <span
              style={{ color: "#EE3A23", fontSize: "14px", fontWeight: "700" }}
            >
             Sent it to all Amealio users
            </span>
          </div>
      </>
     ) : ( 
      <> 
      {wholeData?.DobStarDate && wholeData?.DobSEndDate && (
        <>
          <div className="f10-400 my-1">
            <span
              style={{ color: "#EE3A23", fontSize: "14px", fontWeight: "700" }}
            >
              Date of birth :
            </span>
            <span>
              From : {wholeData?.DobStarDate} To : {wholeData?.DobSEndDate}
            </span>
          </div>
        </>
      )}
      {wholeData?.ActiveUsersStartdate && wholeData?.ActiveUsersenddate && (
        <div className="f10-400 my-1">
          <span
            style={{ color: "#EE3A23", fontSize: "14px", fontWeight: "700" }}
          >
            {" "}
            Active User's paramaters :
          </span>{" "}
          <span>
            {" "}
            From : {wholeData?.ActiveUsersStartdate} To :{" "}
            {wholeData?.ActiveUsersenddate}
          </span>
        </div>
      )}
      {wholeData?.AnniversaryStarDate && wholeData?.AnniversaryEndDate && (
        <div className="f10-400 my-1">
          <span
            style={{ color: "#EE3A23", fontSize: "14px", fontWeight: "700" }}
          >
            {" "}
            User's Anniversary with Amealio :
          </span>{" "}
          <span>
            {" "}
            From : {wholeData?.AnniversaryStarDate} To :{" "}
            {wholeData?.AnniversaryEndDate}
          </span>
        </div>
      )}
      {wholeData?.country && (
        <div className="f10-400 my-1">
          <span
            style={{ color: "#EE3A23", fontSize: "14px", fontWeight: "700" }}
          >
            {" "}
            country :
          </span>{" "}
          <span>{wholeData?.country}</span>
        </div>
      )}
      {wholeData?.state && (
        <div className="f10-400 my-1">
          <span
            style={{ color: "#EE3A23", fontSize: "14px", fontWeight: "700" }}
          >
            {" "}
            state :
          </span>{" "}
          <span>{wholeData?.state}</span>
        </div>
      )}
      {wholeData?.city && (
        <div className="f10-400 my-1">
          <span
            style={{ color: "#EE3A23", fontSize: "14px", fontWeight: "700" }}
          >
            {" "}
            city :
          </span>{" "}
          <span>{wholeData?.city}</span>
        </div>
      )}
      {wholeData?.gender?.length ? (
        <div className="f10-400 my-1">
          <span
            style={{ color: "#EE3A23", fontSize: "14px", fontWeight: "700" }}
          >
            {" "}
            gender :
            {wholeData?.gender?.map((data, index) => {
              return <span> {data?.label} </span>;
            })}
          </span>
        </div>
      ) : null}
      {wholeData?.Allergies?.length ?  (
        <div className="f10-400 my-1">
          <span
            style={{ color: "#EE3A23", fontSize: "14px", fontWeight: "700" }}
          >
            {" "}
            Allergies :
            {wholeData?.Allergies?.map((data, index) => {
              return <span> {data?.label} </span>;
            })}
          </span>
        </div>
      )  : null}
      {wholeData?.Dietary?.length ? (
        <div className="f10-400 my-1">
          <span
            style={{ color: "#EE3A23", fontSize: "14px", fontWeight: "700" }}
          >
            {" "}
            Dietary :
            {wholeData?.Dietary?.map((data, index) => {
              return <span> {data?.label} </span>;
            })}
          </span>
        </div>
      ) : null}
      {wholeData?.Cuisines?.length ? (
        <div className="f10-400 my-1">
          <span
            style={{ color: "#EE3A23", fontSize: "14px", fontWeight: "700" }}
          >
            {" "}
            Cuisines :
            {wholeData?.Cuisines?.map((data, index) => {
              return <span> {data?.label} </span>;
            })}
          </span>
        </div>
      ) : null}
    </>
     )}
   </>
  );
};
